import { useState, useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import useSelectedAsset from './useSelectedAsset';
import addVectorTiles from '../utils/addVectorTiles';
import createLayerToggle from '../utils/createLayerToggle';
// import mapPopUpTable from '../utils/mapPopUpTable';
import config from '../config';

export default function useZoomedMap({
  stateSchema,
  locationIDs,
  handleLocationIDsChange,
  riverID,
  handleRiverIDChange,
  operationalStates
}) {
  const { selectedAsset, assetLoaded } = useSelectedAsset({
    stateSchema,
    locationIDs,
    handleLocationIDsChange,
    riverID,
    handleRiverIDChange
  });

  mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
  const zoomedMap = useRef(null);

  const [toggleableLayers, setToggleableLayers] = useState();
  const [mapStyle, setMapStyle] = useState('streets-v11');

  const handleMapStyleChange = (newStyle) => setMapStyle(newStyle);

  useEffect(() => {
    if (!selectedAsset.asset.sourceInfo.data) {
      const map = new mapboxgl.Map({
        container: zoomedMap.current,
        style: 'mapbox://styles/mapbox/' + mapStyle,
        attributionControl: false,
        bounds: config.conusBounds // [lon, lat] corners [LL, UR]
      });

      setToggleableLayers(
        createLayerToggle(['3DEP Elevation', 'NHD Flowlines'], map)
      );

      return () => map.remove();
    } else {
      if (assetLoaded) {
        const map = new mapboxgl.Map({
          container: zoomedMap.current,
          style: 'mapbox://styles/mapbox/' + mapStyle,
          attributionControl: false,
          center: selectedAsset.center,
          zoom: selectedAsset.zoom
        });

        map.addControl(new mapboxgl.FullscreenControl());
        map.addControl(new mapboxgl.NavigationControl());

        map.on('load', function () {
          addVectorTiles(
            map,
            'zoom',
            stateSchema,
            operationalStates[stateSchema].cogTileServ
          );

          map.addSource(
            selectedAsset.river.name,
            selectedAsset.river.sourceInfo
          );
          map.addLayer(selectedAsset.river.layerInfo);

          map.addSource(selectedAsset.xs.name, selectedAsset.xs.sourceInfo);
          map.addLayer(selectedAsset.xs.layerInfo);

          map.addSource(
            selectedAsset.asset.name,
            selectedAsset.asset.sourceInfo
          );
          map.addLayer(selectedAsset.asset.layerInfo);

          // [selectedAsset.asset, selectedAsset.river, selectedAsset.xs].forEach(
          //   (layer) => {
          //     map.on('click', layer.layerInfo.id, function (e) {
          //       new mapboxgl.Popup()
          //         .setLngLat(e.lngLat)
          //         .setHTML(mapPopUpTable(e.features[0]))
          //         .addTo(map);
          //     });

          //     map.on('mouseenter', layer.layerInfo.id, () => {
          //       map.getCanvas().style.cursor = 'pointer';
          //     });

          //     // Change it back to a pointer when it leaves.
          //     map.on('mouseleave', layer.layerInfo.id, () => {
          //       map.getCanvas().style.cursor = '';
          //     });
          //   }
          // );
        });

        setToggleableLayers(
          createLayerToggle(
            [
              '3DEP Elevation',
              'NHD Flowlines',
              'River',
              'XS',
              'Model Elevation'
            ],
            map
          )
        );

        return () => map.remove();
      }
    }
  }, [selectedAsset, mapStyle, assetLoaded, stateSchema, operationalStates]);

  return { zoomedMap, handleMapStyleChange, toggleableLayers };
}
